import React, { useEffect } from "react";
import { Grid, IconButton, Typography } from "@mui/material";
import { FormattedMessage } from "react-intl";

import { style } from "./style";

import AvailabilitySettingListing from "../AvailabilityListing";
import Button from "@/components/Button";
import GetImages from "@/components/GetImages";
import AvailabilityFilter from "../AvailabilityFilter";
import Loader from "@/components/Loader";
import { DetailedAvailability } from "@/components/AvailabilitySettings";

import { useAppDispatch, useAppSelector } from "@/store/hooks";
import {
  setTopBarDropdownItems,
  setTopBarDropdownMultipleItems,
} from "@/store/slices/doctor/topNavigation";
import {
  availabilitySettings,
  fetchAvailabilitySettingsListing,
  setIsEditAvailability,
  setSelectedAvailabilitySetting,
  setSelectedAvailabilitySettingDetail,
} from "@/store/slices/doctor/availabilitySettings";

import { IProfileDropdownEnums } from "@/models/doctor";

import { topBarDropdownDispatchingEnums } from "@/utils";

const AvailabilitySettingDesktop: React.FC = () => {
  const dispatch = useAppDispatch();
  const {
    isLoading,
    selectedAvailabilitySettingDetail,
    availabilitySettingsListing,
  } = useAppSelector(availabilitySettings);

  const closeHandler = () => {
    dispatch(
      setTopBarDropdownItems(
        topBarDropdownDispatchingEnums[
          IProfileDropdownEnums.AVAILABILITY_SETTINGS
        ]
      )
    );
    dispatch(setSelectedAvailabilitySetting(null));
    dispatch(setSelectedAvailabilitySettingDetail(null));
  };

  const createEditAvailabilityHandler = () => {
    dispatch(setIsEditAvailability(false));
    dispatch(
      setTopBarDropdownMultipleItems([
        topBarDropdownDispatchingEnums[
          IProfileDropdownEnums.CREATE_EDIT_AVAILABILITY
        ],
        topBarDropdownDispatchingEnums[
          IProfileDropdownEnums.AVAILABILITY_SETTINGS
        ],
      ])
    );
  };

  useEffect(() => {
    dispatch(fetchAvailabilitySettingsListing({}));
  }, []);

  useEffect(() => {
    if (availabilitySettingsListing.length > 0) {
      dispatch(setSelectedAvailabilitySetting(availabilitySettingsListing[0]));
    }
  }, [availabilitySettingsListing]);

  return (
    <Grid item>
      {isLoading ? (
        <Loader />
      ) : (
        <>
          <Grid item sx={style.avilabilityTopContainer}>
            <Typography variant="h4">
              <FormattedMessage
                id="availability_settings"
                defaultMessage="Availability Settings"
              />
            </Typography>
            <Grid item sx={style.addNewAvailability}>
              <Button btnTrigger={createEditAvailabilityHandler}>
                <GetImages name="ScheduleIconSelected" width="30" height="24" />
                <FormattedMessage id="create_new" defaultMessage="Create New" />
              </Button>

              <IconButton sx={style.closebutton} onClick={closeHandler}>
                <GetImages
                  name="UniSearchDesktopCloseIcon"
                  width="20"
                  height="20"
                />
              </IconButton>
            </Grid>
          </Grid>
          <Grid item>
            <AvailabilityFilter />
          </Grid>
          <Grid item sx={style.availabilityListingCreateUpdateContainer}>
            <Grid
              item
              sx={
                availabilitySettingsListing?.length === 0
                  ? style.noAvailabilityList
                  : style.availabilityList
              }
            >
              <AvailabilitySettingListing />
            </Grid>
            {selectedAvailabilitySettingDetail && (
              <Grid item sx={style.detailedAvailabilityContainer}>
                <DetailedAvailability />
              </Grid>
            )}
          </Grid>
        </>
      )}
    </Grid>
  );
};

export default AvailabilitySettingDesktop;
